import './App.css';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Aos from 'aos';
import { useState } from 'react';
import 'aos/dist/aos.css';
import 'animate.css';

function App() {
  Aos.init();
  const [open, setOpen] = useState(false);
  return (
    <div className="bg-background text-white" id="home">
      <div className="flex flex-col overflow-hidden font-monda">
        <BrowserRouter>
          <Header setOpen={setOpen} headerOpen={open} />
          <div className={`bg-image flex-1 ${open ? 'hidden' : 'block'}`}>
            <Routes>
              <Route path="/" element={<Home />} />
            </Routes>
            <Footer />
          </div>
        </BrowserRouter>
      </div>
    </div>
  );
}

export default App;
